import React from 'react';

import { useTranslation } from './context';

import { CollectionId } from './types';

export default function (
  collectionIds: CollectionId[],
  Fallback?: React.ComponentType<any>
) {
  return function <P extends object>(WrappedComponent: React.ComponentType<P>) {
    return function WithCollection(props: P) {
      const {
        checkMissingCollection,
        fetchMissingTranslation,
      } = useTranslation();

      const missingCollection = checkMissingCollection(collectionIds);

      const [isCollectionReady, setCollectionReady] = React.useState<boolean>(
        missingCollection.length <= 0
      );

      React.useEffect(() => {
        if (missingCollection.length > 0) {
          fetchMissingTranslation(missingCollection).then(() => {
            setCollectionReady(true);
          });
        }
      }, [missingCollection.length]);

      return (
        <React.Suspense fallback={Fallback ? <Fallback /> : null}>
          {isCollectionReady ? (
            <WrappedComponent {...props} />
          ) : Fallback ? (
            <Fallback />
          ) : null}
        </React.Suspense>
      );
    };
  };
}
